module.exports = __webpack_public_path__ + "static/media/Connect.eb76ef1e.svg";